<template>
    <div>
        <v-dialog max-width="800px" persistent v-model="showPaymentModal" @close="close">
            <v-card flat>

                <v-card-title>
                    <span class="headline">Pagamento</span>
                </v-card-title>
                <v-divider></v-divider>

                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 sm6 md4 px-2>
                                <v-select v-model="paymentMethod"
                                      :error-messages="paymentMethodErrors"
                                      :items="paymentMethods"
                                      item-text="name"
                                      item-value="id"
                                      :disabled="!pendentValue"
                                      @blur="$v.paymentMethod.$touch()"
                                      label="Método Pagamento"></v-select>
                            </v-flex>
                            <v-flex xs12 sm6 md3 px-2>
                                <v-text-field type="number" v-model.number="paymentValue"
                                      :error-messages="paymentValueErrors"
                                      min="0"
                                      persistent-hint
                                      :hint="pendentValue ? 'Pendente('+getPendentValue+')' : 'pago'"
                                      :disabled="!pendentValue"
                                      @blur="$v.paymentValue.$touch()"
                                      label="Valor"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                                <v-menu
                                    ref="dataMenu1"
                                    v-model="dataMenu1"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    max-width="290px"
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            :value="computedPaymentDate"
                                            label="Data pagamento"
                                            :disabled="!pendentValue"
                                            prepend-icon="event"
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker locale="pt" v-model="paymentDate" no-title @input="dataMenu1 = false"></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <!--<v-flex xs12 sm6 md2>-->
                                <!--<v-checkbox-->
                                        <!--small-->
                                        <!--v-model="printReceipt"-->
                                        <!--:disabled="!pendentValue"-->
                                        <!--label="Download Recibo"-->
                                <!--&gt;</v-checkbox>-->
                            <!--</v-flex>-->

                            <v-flex xs12>
                                <v-textarea
                                    v-model="paymentDescription"
                                    outline
                                    rows=3
                                    label="Observação(opcional)"
                                ></v-textarea>
                            </v-flex>


                            <v-flex xs12>
                                <table v-if="showListPayment" class="table table-bordered" border="1" style="border-collapse: collapse;">
                                    <tr>
                                        <th align="left">Método</th>
                                        <th align="right" style="width: 40%">Valor</th>
                                        <th></th>
                                    </tr>
                                    <tr v-for="(payment, index) in payments" :key="index">
                                        <td>{{getPaymentMethodNameById(payment.types_payment_method_id)}}</td>
                                        <td align="right">{{payment.value | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</td>
                                        <td><v-icon color="red" small class="mr-2" @click="virtuallyRemovePayment(index)">clear</v-icon></td>
                                    </tr>
                                    <tr v-if="showListPayment">
                                        <td><span style="color: grey">Total:</span></td>
                                        <td align="right"><span style="color: grey">{{getTotalPayments | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</span></td>
                                        <td></td>
                                    </tr>
                                </table>
                            </v-flex>

                        </v-layout>

                        <!--Alert Must ZeroOut Pendent value-->
                        <v-alert style="margin-top: 10px"
                            v-if="showAlertMustZeroOutPendentValue"
                            :value="true"
                            color="info"
                            icon="info"
                            outline >Em "Pronto Pagamento" não se pode ter valor pendente ainda por pagar.
                        </v-alert>
                    </v-container>
                </v-card-text>


                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div v-if="!loading_modal">
                        <v-btn ma-2 depressed @click="close">Cancelar</v-btn>
                        <v-btn ma-2 :disabled="checkDoneButton" color="primary" @click="openAskNewModal">Confirmar</v-btn>
                    </div>
                    <v-progress-circular v-else indeterminate color="primary" m-2 ></v-progress-circular>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--Confirmation Dialog-->
        <v-dialog persistent max-width="500" v-model="openAskIfNewPaymentModal" @close="close">
            <v-card>
                <!--<v-card-title class="headline">Use Google's location service?</v-card-title>-->
                <v-card-text class="text-xs-center">
                    <p>Deseja adicionar outro pagamento a este recibo?</p>
                </v-card-text>
                <v-card-actions>
                    <v-btn ma-2 depressed @click="cancelAskNew()">Cancelar</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="letAddNewPayment">Sim</v-btn>
                    <v-btn color="grey darken-1" flat @click="save">Não & Concluir</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
    import Vue from 'vue';
    import {minValue, maxValue, required} from 'vuelidate/lib/validators'
    import {mapGetters} from 'vuex';
    import {eventBus} from "../../main";
    import moment from 'moment';

    export default {
        name: "AddPayment",
        mounted(){
            this.$moment.locale('pt');
        },

        data(){
            return {
                showPayments: false,
                showAlertMustZeroOutPendentValue: false,
                loading_modal: false,
                openAskIfNewPaymentModal: false,
                dataMenu1: false,
                printReceipt: true,
                paymentValue: '',
                paymentDate: '',
                paymentDescription: '',
                paymentMethod: '',
                payments: [],
                observation: '',
            }
        },

        // props:[
        //     'paymentMethods', 'invoiceId', 'pendentValue', 'isProntoPagamento'
        // ],

        props: {
            paymentMethods: Array,
            invoiceId: Number,
            invoiceList: Array,
            pendentValue: Number,
            mClient: Object,
            isProntoPagamento: {
                type: Boolean,
                default: false
            },
        },

        methods: {

            addPayment(){
                if(!this.paymentMethod || !this.paymentValue) return;
                this.payments.push({
                    'types_payment_method_id': this.paymentMethod,
                    'value': this.paymentValue
                });
            },

            openAskNewModal(){
                this.addPayment();
                // this.consoleLog('----openAskNewModal-----');
                // this.consoleLog('pendentValue: '+this.getPendentValue);
                // this.consoleLog('paymentValue: '+this.paymentValue);
                // this.consoleLog('totalPayments: '+this.getTotalPayments);
                if(this.getPendentValue === 0){
                    this.showAlertMustZeroOutPendentValue = false;
                    this.save();
                    return;
                }
                if(!this.isProntoPagamento){
                    this.openAskIfNewPaymentModal = true;
                }else{
                    this.showAlertMustZeroOutPendentValue = true;
                    this.showPayments = true;
                    this.paymentValue = this.getPendentValue;
                }

            },

            cancelAskNew(){
                // this.addPayment();
                let lastIndex = this.payments.length - 1;
                if(lastIndex < 0) return;
                this.virtuallyRemovePayment(lastIndex);

                this.openAskIfNewPaymentModal = false
            },

            closeAskNewPaymentModal(){
                this.openAskIfNewPaymentModal = false;
            },

            getPaymentMethodNameById(id){
                for(let i=0; i<this.paymentMethods.length; i++){
                    if(this.paymentMethods[i].id === id){
                        this.consoleLog(this.paymentMethods[i]);
                        return this.paymentMethods[i].name;
                    }
                }
            },

            virtuallyRemovePayment(index){
                this.payments.splice(index, 1);
                if(!this.payments.length) this.showPayments = false;
            },

            save(){
                if(!this.isProntoPagamento){
                    this.saveReceiptAndPayments();
                    
                }else{
                    this.consoleLog(this.payments);
                    if(this.getPendentValue > 0 && this.getPendentValue > this.paymentValue){
                        this.showAlertMustZeroOutPendentValue = true;
                        return;
                    }
                    
                    eventBus.$emit('onPaymentAdded', this.payments, this.paymentDescription);
                    this.$emit('onPaymentAdded', {
                        payments: this.payments,
                        paymentDescription: this.paymentDescription
                    });
                    this.close();
                }
            },

            saveReceiptAndPayments(){
                this.loading_modal = true;
                this.openAskIfNewPaymentModal = false;
                this.consoleLog(this.payments);
                Vue.axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.getToken;
                Vue.axios.post('receipt', {
                    payments: JSON.stringify(this.payments),
                    paymentMethos: this.paymentMethod,
                    paymentValue: this.paymentValue,
                    paymentDate: this.paymentDate,
                    paymentDescription: this.paymentDescription,
                    invoices_id: this.invoiceId,
                }).then(response=>{
                    this.consoleLog(response);
                    if(!response.data.success){
                        eventBus.$emit('onReceiptSave', false);
                        this.payments = [];
                        return;
                    }
                    eventBus.$emit('onReceiptSave', response.data.response);
                    this.close();

                }).catch(error=>{
                    this.consoleLog(error);
                    this.payments = [];
                    eventBus.$emit('onReceiptSave', false);

                }).finally(()=>{
                    this.loading_modal = false;
                });
            },

            letAddNewPayment(){
                this.showPayments = true;
                this.showAlertMustZeroOutPendentValue = false;

                this.paymentValue = this.getPendentValue;
                this.paymentMethod = '';
                this.closeAskNewPaymentModal();
                this.$v.paymentMethod.$reset();
            },

            reset(){
                this.paymentValue = '';
                this.paymentMethod = '';
                this.$v.$reset();
                this.closeAskNewPaymentModal();
                this.showAlertMustZeroOutPendentValue = false;
            },

            close(){
                this.showPayments = false;
                this.showPaymentModal = false;
                this.paymentDate = '';
                this.paymentDescription = '';
                this.reset();
                this.payments = [];
            },

            onModalOpen(){
                this.consoleLog("onModalOpen -- computedTotal::::", this.pendentValue);
                setTimeout(function () {
                    this.paymentValue = this.pendentValue;
                    this.paymentDate = new Date().toISOString().substr(0, 10);
                    
                }.bind(this), 10)
            }
        },

        validations: {

            paymentMethod: {
                required,
            },
            paymentValue: {
                required,
                minValue: minValue(0.01),
            },
        },

        watch: {
            showPaymentModal() {
                if(this.showPaymentModal){
                    this.onModalOpen();
                }
            },

        },

        computed:{
            ...mapGetters([
                'getToken'
            ]),
            showPaymentModal:{
                get(){
                    return this.$store.getters.getShowPaymentModal;
                },
                set(value){
                    this.$store.dispatch('setShowPaymentModal', value);
                }
            },

            computedPaymentDate:{
                get(){
                    return this.paymentDate ? moment(this.paymentDate).format('DD-MM-YYYY') : moment().format('DD-MM-YYYY');
                },
                set(value){
                    this.paymentDate = new Date(value).toISOString().substr(0, 10);
                }
            },

            getTotalPayments(){
                let total = 0;
                for(let i=0; i<this.payments.length; i++){
                    total += parseFloat(this.payments[i].value);
                }
                return total;
            },

            getPendentValue(){
                // this.pendentValue = this.pendentValue - this.getTotalPayments;
                return parseFloat(this.pendentValue - this.getTotalPayments);
            },

            showListPayment(){
                return this.payments.length > 0 && this.showPayments;
            },

            paymentMethodErrors(){
                const errors = [];
                if (!this.$v.paymentMethod.$dirty) return errors;
                !this.$v.paymentMethod.required && errors.push('Escolha um Método pagamento');
                return errors
            },
            paymentValueErrors(){
                const errors = [];
                if (!this.$v.paymentValue.$dirty) return errors;
                !this.$v.paymentValue.minValue && errors.push('Introduza valores positivos');
                // !this.$v.paymentValue.maxValue && errors.push('Muito');
                !this.$v.paymentValue.required && errors.push('Introduza um valor');
                return errors
            },

            checkDoneButton(){
                return this.$v.$invalid && !this.payments.length
                    || this.paymentValue > this.getPendentValue;
            }
        }
    }
</script>

<style scoped>
    table, tr, th, td {
        border-color: LightGray;
        border-left: none;
        border-right: none;
        border-top: none;
        padding-left: 10px;
        padding-right: 10px;
    }
    table th{
        height: 30px;
    }
    table td{
        height: 25px;
    }

</style>